/* eslint-disable no-return-assign */
import _ from 'lodash';
import { defaultSeason, seasons } from '@/utils/constants';

// Skeleton not final, migrated from NRL
const initState = () => ({
  nationals: {
    search: '',
    data: [],
    filters: {
      isActive: undefined,
    },
    pagination: {
      total: 0,
      pageSize: 20,
      page: 1
    },
  },
  states: {
    search: '',
    filters: {
      isActive: undefined
    },
    data: [],
    pagination: {
      total: 0,
      pageSize: 20,
      page: 1
    },
  },
  associations: {
    search: '',
    filters: {
      isActive: undefined
    },
    data: [],
    pagination: {
      total: 0,
      pageSize: 20,
      page: 1
    },
  },
  associationClubs: {
    search: '',
    filters: {
      isActive: undefined,
      season: +process.env.VUE_APP_NATIONAL_ID === 8 ? seasons.find((s) => s.default).value : defaultSeason
    },
    data: [],
    pagination: {
      total: 0,
      pageSize: 20,
      page: 1
    }
  },
  clubs: {
    search: '',
    filters: {
      isActive: undefined
    },
    data: [],
    pagination: {
      total: 0,
      pageSize: 20,
      page: 1
    }
  },
  clubMemberships: {
    search: '',
    filters: {
      isActive: undefined
    },
    data: [],
    pagination: {
      total: 0,
      pageSize: 20,
      page: 1
    }
  },
  clubTeams: {
    search: '',
    filters: {
      isActive: undefined,
      season: +process.env.VUE_APP_NATIONAL_ID === 8 ? seasons.find((s) => s.default).value : defaultSeason
    },
    data: [],
    pagination: {
      total: 0,
      pageSize: 20,
      page: 1
    }
  },
  teams: {
    search: '',
    filters: {
      isActive: undefined,
      season: +process.env.VUE_APP_NATIONAL_ID === 8 ? seasons.find((s) => s.default).value : defaultSeason
    },
    data: [],
    pagination: {
      total: 0,
      pageSize: 20,
      page: 1
    },
    sort: {}
  },
  memberships: {
    search: '',
    filters: {
      isActive: undefined,
      season: +process.env.VUE_APP_NATIONAL_ID === 8 ? seasons.find((s) => s.default).value : defaultSeason
    },
    data: [],
    pagination: {
      total: 0,
      pageSize: 20,
      page: 1
    }
  },
  venues: {
    search: '',
    filters: {
      isActive: undefined
    },
    data: [],
    pagination: {
      total: 0,
      pageSize: 20,
      page: 1
    }
  }
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    reset: (state) => _.assign(state, initState()),
    // payload: {entity, search}
    updateSearch: (state, payload) => state[payload.entity].search = payload.search,
    // payload: {entity, filters}
    updateFilters: (state, payload) => state[payload.entity].filters = payload.filters,
    // payload: {entity, data}
    updateData: (state, payload) => state[payload.entity].data = payload.data,
    // payload: {entity, pagination}
    updatePagination: (state, payload) => _.assign(state[payload.entity].pagination, payload.pagination),
    updateSort: (state, { sort, entity }) => {
      state[entity].sort = sort;
    },
  }
};
